const movies = [
    {
        name: 'wakanda-forever',
        image: 'https://m.media-amazon.com/images/M/MV5BNTM4NjIxNmEtYWE5NS00NDczLTkyNWQtYThhNmQyZGQzMjM0XkEyXkFqcGdeQXVyODk4OTc3MTY@._V1_SX300.jpg',
        title: 'Wakanda Forever',
        content: [
            `I think Wakanda Forever was an okay movie. People are saying that it was the best Marvel movie from this phase but I disagree. 
            I would give the movie a 6/10, it was definitely better than Shang Chi and the Eternals. Overall it was a fun watch.`
        ]
    },
    {
        name: 'avatar-way-of-water',
        image: 'https://m.media-amazon.com/images/M/MV5BYjhiNjBlODctY2ZiOC00YjVlLWFlNzAtNTVhNzM1YjI1NzMxXkEyXkFqcGdeQXVyMjQxNTE1MDA@._V1_SX300.jpg',
        title: 'Avatar: The Way of Water',
        content: [
            `Probably one of the longest movies i've watched this year. 
            I recommend not drinking anything beforehand because after coming back from the bathroom I felt like I missed a lot of information. 
            Overall I think the movie was great but not as good as the first movie. I would give it a 7/10.`
        ]
    },
    {
        name: 'glass-onion',
        image: 'https://m.media-amazon.com/images/M/MV5BYmZlZDZkZjYtNzE5Mi00ODFhLTk2OTgtZWVmODBiZTI4NGFiXkEyXkFqcGdeQXVyMTE5MTg5NDIw._V1_SX300.jpg',
        title: 'Glass Onion',
        content: [
            `If you are a fan of these types of movies you will enjoy Glass Onion. 
            I thought it was a fun watch and I enjoyed creating my own theories to figure out the murder. 
            I give it a 6/10. `
        ]
    },
];

export default movies;